export default "__VITE_ASSET__CxPM39Nl__"